// SPDX-License-Identifier: BUSL-1.1; Copyright (c) 2025 Social Connect Labs, Inc.; Licensed under BUSL-1.1 (see LICENSE); Apache-2.0 from 2029-06-11

// src/observability/onboardingContext.ts
var COHORT_TAG_KEYS = [
  "attempt_id",
  "initial_branch",
  "current_branch",
  "document_country",
  "document_type",
  "signature_algorithm",
  "csca_hash_algorithm",
  "kyc_provider"
];
var REDACTED = "[REDACTED]";
var SENSITIVE_KEY_PATTERN = /passport|mrz|dg\d|chip|aadhaar|(?:first|last|full|given|family|holder|sur)_?name|name_?(?:first|last|of_?holder|holder)|date_?of_?birth|dob|birth|photo|email/i;
function isOnboardingEvent(eventName) {
  return eventName.startsWith("Onboarding:") || eventName.startsWith("Biometric:") || eventName.startsWith("KYC:") || eventName.startsWith("Aadhaar:") || eventName.startsWith("Passport:");
}
function tagsFromAnalyticsEvent(eventName, properties) {
  if (!properties) return {};
  if (!isOnboardingEvent(eventName)) return {};
  const snapshot = {};
  const setString = (key, value) => {
    if (typeof value === "string") snapshot[key] = value;
  };
  setString("attempt_id", properties.attempt_id);
  setString("initial_branch", properties.initial_branch);
  setString("current_branch", properties.current_branch);
  setString("document_country", properties.country_code);
  setString("document_type", properties.document_type);
  setString("signature_algorithm", properties.signature_algorithm);
  setString("csca_hash_algorithm", properties.csca_hash_algorithm);
  if (eventName.startsWith("KYC:")) {
    setString("kyc_provider", properties.provider);
  }
  return snapshot;
}
function sanitizeTagValue(value) {
  if (value == null) return "";
  const MAX_TAG_LENGTH = 200;
  const normalized = String(value).replace(/[<>&"']/g, (char) => {
    switch (char) {
      case "<":
        return "&lt;";
      case ">":
        return "&gt;";
      case "&":
        return "&amp;";
      case '"':
        return "&quot;";
      case "'":
        return "&#x27;";
      default:
        return char;
    }
  }).replace(/[^\x20-\x7E]/g, "");
  return normalized.length > MAX_TAG_LENGTH ? normalized.slice(0, MAX_TAG_LENGTH - 3) + "..." : normalized;
}
function stripUrlQuery(url) {
  const cut = url.search(/[?#]/);
  return cut === -1 ? url : url.slice(0, cut);
}
var URL_BREADCRUMB_KEYS = ["url", "to", "from"];
function redactObjectInPlace(obj) {
  for (const key of Object.keys(obj)) {
    if (SENSITIVE_KEY_PATTERN.test(key)) {
      obj[key] = REDACTED;
      continue;
    }
    const value = obj[key];
    if (value && typeof value === "object") {
      redactObjectInPlace(value);
    }
  }
  return obj;
}
function redactSensitiveFields(event) {
  if (event.breadcrumbs) {
    for (const crumb of event.breadcrumbs) {
      if (crumb.data) {
        redactObjectInPlace(crumb.data);
        for (const key of URL_BREADCRUMB_KEYS) {
          if (typeof crumb.data[key] === "string") {
            crumb.data[key] = stripUrlQuery(crumb.data[key]);
          }
        }
      }
    }
  }
  if (event.contexts) {
    redactObjectInPlace(event.contexts);
  }
  if (event.extra) {
    redactObjectInPlace(event.extra);
  }
  if (event.user) {
    redactObjectInPlace(event.user);
  }
  if (event.request) {
    const request = event.request;
    if (typeof request.url === "string") request.url = stripUrlQuery(request.url);
    delete request.query_string;
    delete request.cookies;
    delete request.headers;
    if (request.data && typeof request.data === "object") {
      redactObjectInPlace(request.data);
    }
  }
  return event;
}

export {
  COHORT_TAG_KEYS,
  REDACTED,
  SENSITIVE_KEY_PATTERN,
  tagsFromAnalyticsEvent,
  sanitizeTagValue,
  redactSensitiveFields
};
//# sourceMappingURL=chunk-YOD4VMK2.js.map